import { MaterialType } from "../../../types/materials";
import { ImageCardBaseVariants, ImageCardVariants } from "./types";

export const imageCardVariants: ImageCardVariants[] = [
  ...Object.values(ImageCardBaseVariants),
  ...Object.values(MaterialType),
];
